var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLounge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icn/amenities/lounge") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn/amenities/lounge",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "armchair",
    stroke: "#333333",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.625,14 L23.625,10.5 C23.625,5.18425928 19.3157407,0.875 14,0.875 C8.68425928,0.875 4.375,5.18425928 4.375,10.5 L4.375,14",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1250007,17.5 C27.1256219,15.8882325 26.025468,14.484425 24.4602708,14.0997787 C22.8950736,13.7151324 21.2695606,14.4491088 20.5230471,15.8775739 C19.7765335,17.306039 20.1020524,19.0596215 21.3115,20.125 L6.6885,20.125 C7.82796496,19.1193664 8.18824251,17.4933121 7.58019269,16.1004895 C6.97214287,14.7076669 5.5347366,13.8664084 4.02258924,14.0183612 C2.51044189,14.170314 1.26915757,15.280749 0.950390749,16.7667056 C0.63162393,18.2526622 1.30822937,19.7745222 2.625,20.5333333 L2.625,23.625 C2.625,24.5914983 3.40850169,25.375 4.375,25.375 L23.625,25.375 C24.5914983,25.375 25.375,24.5914983 25.375,23.625 L25.375,20.5333333 C26.4585985,19.9077178 27.1258022,18.7512313 27.1250007,17.5 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.375,
    y1: 25.375,
    x2: 4.375,
    y2: 27.125,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.625,
    y1: 25.375,
    x2: 23.625,
    y2: 27.125,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.25,
    y1: 8.75,
    x2: 15.75,
    y2: 12.25,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.75,
    y1: 8.75,
    x2: 12.25,
    y2: 12.25,
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLounge);
export default __webpack_public_path__ + "static/media/lounge.cdc70ca6690d5a2db594572b54d91bc1.svg";
export { ForwardRef as ReactComponent };